import type { ComputedRef, InjectionKey, Ref, Slots, UnwrapRef } from 'vue'
import type { BaseTabsProps } from './tabs'

export type BaseTabsPaneContext = UnwrapRef<{
  uid: number
  slots: Slots
  props: BaseTabsProps
  paneName: ComputedRef<string | number | undefined>
  active: ComputedRef<boolean>
  index: Ref<string | undefined>
  isClosable: ComputedRef<boolean>
}>

export interface BaseTabsRootContext {
  props: BaseTabsProps
  currentName: Ref<string | number>
  registerPane: (pane: BaseTabsPaneContext) => void
  unregisterPane: (uid: number) => void
}

export const tabsRootContextKey: InjectionKey<BaseTabsRootContext> = Symbol(
  'baseTabsRootContextKey'
)
